import React from 'react';
import displayName from 'component-lib/displayName';

import EmptyResultsBase from './EmptyResultsBase';
import ReportsEmptyResultsImage from './Empty-reports.png';

export default function ReportsEmptyResults(props) {
    return <EmptyResultsBase image={ReportsEmptyResultsImage} {...props} />;
}

ReportsEmptyResults.displayName = displayName('EmptyPageViews/ReportsEmptyResults');

ReportsEmptyResults.defaultProps = {
    name: 'reports',
};
